/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MethodData } from './methodData';


/**
 * Info about document create method
 */
export interface StartMethodInfo { 
    startMethod?: MethodData;
    /**
     * Start method is available
     */
    isAvailable: boolean;
    /**
     * Info message
     */
    info?: string | null;
}

